<script lang="ts">
	import { t } from 'svelte-i18n';
	import UserNavNotificationsStatus from './UserNavNotificationsStatus.svelte';
	import UserNavNotificationsList from './UserNavNotificationsList.svelte';

	let modal;

	async function loadModal() {
		const { default: Modal } = await import('@wiseed/wikit');
		modal = Modal;
	}

	function closeModal() {
		modal = false;
	}
</script>

<div>
	<UserNavNotificationsStatus on:click={loadModal} />
	<svelte:component this={modal} on:closeModal={closeModal}>
		<div slot="title" class="flex items-center space-x-4">
			<div class="capitalize">
				{$t('notifications')}
			</div>
		</div>
		<div slot="body">
			<UserNavNotificationsList nbShown={4} onClickButtonFunction={closeModal} />
		</div>
	</svelte:component>
</div>

<style lang="postcss">
	div :global(.modal) {
		@apply !w-full !h-full !max-h-full !rounded-none;
	}
</style>
